import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { PublicShell } from "@/components/PublicNav";
import { api } from "@/lib/api";
import { Calendar } from "lucide-react";

export const Blog = () => {
  const [posts, setPosts] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get("/public/blogs").then(({ data }) => setPosts(data)).finally(() => setLoading(false));
  }, []);

  return (
    <PublicShell>
      <section className="zq-hero-bg">
        <div className="max-w-5xl mx-auto px-5 md:px-8 py-16 md:py-20 text-center">
          <span className="zq-pill zq-pill-orange">Blog</span>
          <h1 className="text-4xl sm:text-5xl lg:text-6xl font-bold mt-4">Stories, guides & insights</h1>
          <p className="text-zq-muted mt-5 max-w-2xl mx-auto">From running a chai stall to scaling a multi-city brand — written for Indian restaurateurs.</p>
        </div>
      </section>

      <section className="zq-section pt-0">
        <div className="max-w-6xl mx-auto">
          {loading ? (
            <p className="text-center text-zq-muted">Loading…</p>
          ) : posts.length === 0 ? (
            <p className="text-center text-zq-muted">No posts yet.</p>
          ) : (
            <div className="grid md:grid-cols-3 gap-6">
              {posts.map((p) => (
                <Link
                  key={p.id}
                  to={`/blog/${p.slug}`}
                  className="zq-card overflow-hidden hover:-translate-y-1 transition"
                  data-testid={`blog-card-${p.slug}`}
                >
                  {p.featured_image && (
                    <img src={p.featured_image} alt={p.title} className="w-full h-44 object-cover" />
                  )}
                  <div className="p-5">
                    <h3 className="font-semibold text-base leading-snug">{p.title}</h3>
                    <p className="text-sm text-zq-muted mt-2 line-clamp-3">{p.excerpt}</p>
                    <div className="flex items-center gap-1 text-xs text-zq-muted mt-4">
                      <Calendar size={12} />
                      {new Date(p.created_at).toLocaleDateString("en-IN", { day: "numeric", month: "short", year: "numeric" })}
                    </div>
                  </div>
                </Link>
              ))}
            </div>
          )}
        </div>
      </section>
    </PublicShell>
  );
};
